exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".regist_input_div[data-v-71b87faf]{margin-top:5%;padding:2px;border-radius:4px;border:1px solid #e52212}.regist_input[data-v-71b87faf]{font-size:16px}.code_button[data-v-71b87faf]{height:50px;width:auto;border:0;padding:0;position:absolute;right:30px}.success_data_div[data-v-71b87faf]{border:1px solid #e52212;border-radius:4px;padding:10px;background-color:rgba(3,255,242,.07);font-size:17px;line-height:32px}.tip_div[data-v-71b87faf]{margin-top:20px;border:1px solid rgba(3,255,242,.33);border-radius:4px;padding:10px;background-color:rgba(3,255,242,.13);font-size:15px;line-height:25px}", ""]);

// exports
